import { EnvironmentOutlined, ExportOutlined } from '@ant-design/icons';
import { Button, Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { IncidentPrimaryAsset } from '~/app/services/incident/incident.service';
import { getPublicAssetUrl } from '~/app/utils/getPublicAssetUrl';
import styles from './IncidentStationAssetCell.module.css';

const { Text } = Typography;

export interface IncidentStationAssetCellProps {
  stationName: string | null | undefined;
  location: string | null | undefined;
  primaryAsset: IncidentPrimaryAsset | null | undefined;
}

export function IncidentStationAssetCell({
  stationName,
  location,
  primaryAsset,
}: IncidentStationAssetCellProps) {
  const { t } = useTranslation('incidents');
  const assetLinkLabel = t(
    'table.openAssetInNewTab',
    'Open asset details in a new tab',
  );
  const chargerIconSrc = getPublicAssetUrl('assets/ev-charger.png');

  return (
    <div className={styles.cell}>
      <div className={styles.header}>
        <EnvironmentOutlined className={styles.locationIcon} aria-hidden />
        <div className={styles.headerText}>
          <Text
            className={styles.stationName}
            ellipsis={{ tooltip: stationName ?? undefined }}
          >
            {stationName ?? '—'}
          </Text>
          <Text
            className={styles.location}
            ellipsis={{ tooltip: location ?? undefined }}
          >
            {location ?? '—'}
          </Text>
        </div>
      </div>
      {primaryAsset ? (
        <div className={styles.assetCard}>
          <div className={styles.iconBox} aria-hidden="true">
            <img
              src={chargerIconSrc}
              alt=""
              className={styles.iconImage}
              width={18}
              height={18}
            />
          </div>
          <div className={styles.assetText}>
            <Text
              className={styles.assetName}
              ellipsis={{ tooltip: primaryAsset.name }}
            >
              {primaryAsset.name}
            </Text>
            <Text
              className={styles.serialText}
              ellipsis={{ tooltip: primaryAsset.serialNumber }}
            >
              {primaryAsset.serialNumber}
            </Text>
          </div>
          <Tooltip title={assetLinkLabel}>
            <Button
              type="text"
              size="small"
              className={styles.openLink}
              icon={<ExportOutlined />}
              href={`/assets/${primaryAsset.id}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={assetLinkLabel}
              onClick={(event) => {
                event.stopPropagation();
              }}
            />
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
}
